import { BaseSportsSubscriber } from "../baseSportsSubscriber";
import { ConnectionNames } from "../../../contracts";
import { sportsbookConnectionHOF } from "../../sportsbookConnectionHOF";
import { isFormatMsgPack } from "../../../common";
import { mapSportsbookProjectionContentCardResponse } from "../mapResponses";
export class SportsbookContentCardEvent extends BaseSportsSubscriber {
    constructor(subscriptionPartial, page, initialData, onDataCallback, onErrorCallback) {
        super(onDataCallback, onErrorCallback);
        this.query = {
            name: this.getName(),
            params: {
                entity: "LiveContentCardEvent",
                queryParams: {
                    eventId: subscriptionPartial.eventId,
                    initialData,
                    projection: "sportsbook",
                    locale: super.getLocale()
                },
                forwardedHeaders: {},
                clientMetadata: Object.assign({ feature: page }, this.clientMetadata),
            }
        };
    }
    onData(x) {
        if (isFormatMsgPack(ConnectionNames.sports) && x instanceof Array) {
            super.onData(mapSportsbookProjectionContentCardResponse(x));
        }
        else {
            super.onData(x);
        }
    }
}
export const SportsbookContentCardEventHOF = sportsbookConnectionHOF(SportsbookContentCardEvent, {}, false);
//# sourceMappingURL=SportsbookContentCardEvent.js.map